(function (Drupal) {
  Drupal.behaviors.modalpqrs = { 
    attach: function (context, settings) {
      const modalTrigger = document.querySelector('.pqrs-modal a');
      const modal_pqrs = document.querySelector('#Modal-pqrs');
      if (modalTrigger || modal_pqrs) {
        modalTrigger.addEventListener("click", function(event) {
          event.preventDefault();
          modal_pqrs.style.display = "block"; 
          modal_pqrs.classList.add("show");
        });
        //modal
        const button_close = document.querySelector('#Modal-pqrs .btn-close');
        button_close.addEventListener("click", function(event) {
          modal_pqrs.style.display = "none"; 
          modal_pqrs.classList.remove("show");

        }); 
        const button_closet = document.querySelector('#Modal-pqrs .btn-primary');
        
        button_closet.addEventListener("click", function(event){
          modal_pqrs.style.display = "none"; 
          modal_pqrs.classList.remove("show");
        })
      }
    }
  };
})(Drupal);
    